{
  "alert.informative": "Informative",
  "alert.negative": "Negative",
  "alert.notice": "Notice",
  "alert.positive": "Positive",
  "chat.newMessage": "New message",
  "chat.scrollToBottom": "Scroll to bottom",
  "messagefeedback.thumbDown": "Bad response",
  "messagefeedback.thumbUp": "Good response",
  "responsestatus.loading": "Loading",
  "responsestatus.processing": "Processing...",
  "voicebutton.stopListening": "Stop recording",
  "voicebutton.startListening": "Start recording",
  "promptfield.placeholder": "Ready to get started? Ask a question, share an idea, or add a task.",
  "promptfield.placeholder.small": "Ask anything",
  "promptfield.aiDisclaimer": "Responses are generated using AI, and may be inaccurate. Check before using.",
  "promptfield.aiUserGuidlines": "AI User Guidelines",
  "promptfield.attachments": "Attachments",
  "promptfield.label": "AI Prompt",
  "promptfield.stopButton": "Stop AI prompt",
  "promptfield.submitButton": "Submit AI prompt",
  "promptfield.insertButton": "Add",
  "promptfield.uploading": "Uploading",
  "attachmentlist.previousAttachments": "Show previous attachments",
  "attachmentlist.nextAttachments": "Show next attachments"
}
